import { FIND_DEBTS, FIND_LOG } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

async function findDebts(props: IFindUserInformation) {
  var thisUrl = FIND_DEBTS;

  //   const populateFields =
  //     "blocks financial schoolDriverInformation companyInformation driverInformation.city driverInformation.province driverInformation.plateNumber driverInformation.financialGroup gender driverInformation.subscriptionExpireAt driverInformation.nationalCode driverInformation.driverLicenseNumber driverInformation.insuranceNumber driverInformation.address driverInformation.uniqueCodeThirdPartyInsurance driverInformation.approved driverInformation.carBrand driverInformation.carModel driverInformation.carColor driverInformation.carSystem driverInformation.insuranceExpiryDate driverInformation.vin avatar";

  //   thisUrl += `&populate=${populateFields}`;

  //   let schoolDriverInformation;
  //   if (props.companyId) {
  //     schoolDriverInformation = {
  //       "schoolDriverInformation.company": props.companyId,
  //     };
  //   }

  let body: any = {
    page: props.page,
    limit: props.limit,
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  // if (props?.search?.value) {
  //   body = {
  //     query: {
  //       ...body.query,
  //       [String(props.search.base)]: utils.convertNumbers2English(
  //         props.search.value
  //       ),
  //     },
  //   };
  // }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.filters) {
    const { superAgent, driver, company, type, province, city } = props.filters;

    body = {
      ...body,
      superAgent: superAgent,
      driver: driver,
      company: company,
      type: type,
      province: province,
      city: city,
    };
  }

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findDebts;
